import {createContext, useContext, useState, useCallback} from 'react'

interface FiltersCollapseContext {
  allCollapsed: boolean
  toggleAll: () => void
  collapseVersion: number
}

const FiltersCollapseContext = createContext<FiltersCollapseContext | undefined>(undefined)

export const useFiltersCollapse = () => {
  return useContext(FiltersCollapseContext)
}

export const FiltersCollapseProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [allCollapsed, setAllCollapsed] = useState(false)
  const [collapseVersion, setCollapseVersion] = useState(0)

  const toggleAll = useCallback(() => {
    setAllCollapsed((prev) => !prev)
    setCollapseVersion((v) => v + 1)
  }, [])

  return (
    <FiltersCollapseContext.Provider value={{allCollapsed, toggleAll, collapseVersion}}>
      {children}
    </FiltersCollapseContext.Provider>
  )
}
